import React, { FC } from "react";
import "./App.scss";
import useImages from "./helpers/useImages";
import useNodeId from "./helpers/useNodeId";
import useNode from "./helpers/useNode";
import BuyBox from "./components/BuyBox";
import VIPBanner from "./components/VIPBanner";

// TODO Realize mini cards (if more then 20 elements)
// TODO Provide adaptive design

const App: FC = () => {
  const nodeId = useNodeId();
  const { imageIds } = useNode(nodeId);

  const { images } = useImages(imageIds);

  return (
    <>
    <VIPBanner />
    <div className={`gallery-grid${images.length > 12 ? " mini" : ""}`}>
      {images.map((image) => (
        <div className={"gallery-item"} key={`img${image.id}`}>
          <img
            src={`/ymaxiProduct/billing2/php/modules/magazine/files/imgtovar/${image.previewFull}`}
            alt={image.name}
          />
          <BuyBox image={image} />
        </div>
      ))}
    </div>
    </>
  );
};

export default App;
